export enum DocumentTypes {
    Contract,
}